var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFocus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a.8.8 0 0 1 .8.8v1.239a7.972 7.972 0 0 1 7.161 7.161H21.2a.8.8 0 0 1 0 1.6h-1.239a7.972 7.972 0 0 1-7.161 7.161V21.2a.8.8 0 1 1-1.6 0v-1.239A7.972 7.972 0 0 1 4.039 12.8H2.8a.8.8 0 0 1 0-1.6h1.239A7.972 7.972 0 0 1 11.2 4.039V2.8A.8.8 0 0 1 12 2zm.8 16.498V16.8a.8.8 0 1 0-1.6 0v1.698A6.51 6.51 0 0 1 5.502 12.8H7.2a.8.8 0 0 0 0-1.6H5.502A6.51 6.51 0 0 1 11.2 5.502V7.2a.8.8 0 0 0 1.6 0V5.502a6.51 6.51 0 0 1 5.698 5.698H16.8a.8.8 0 0 0 0 1.6h1.698a6.51 6.51 0 0 1-5.698 5.698z",
    fill: "#4C4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFocus);
export default __webpack_public_path__ + "static/media/ic_focus.55637d8e77a793eb383eba949ac2d79d.svg";
export { ForwardRef as ReactComponent };